import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { projects } from "../../data/projects";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container className="project-list-page-inner">
        <h1 className="project-heading">
          My <strong className="purple">Projects </strong>
        </h1>
        <p className="project-list-lead">
          SaaS products—architecture, tenancy, and shipping real workflows.
        </p>
        <Row>
          {projects.map((project) => (
            <Col xs={12} className="project-card project-card-wide" key={project.slug}>
              <ProjectCard
                slug={project.slug}
                title={project.title}
                link={project.link}
                summary={project.detail?.overview?.intro}
                techTags={project.techTags}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
